import { render } from "./tw-label.vue?vue&type=template&id=3017d376"
import script from "./tw-label.vue?vue&type=script&lang=js"
export * from "./tw-label.vue?vue&type=script&lang=js"
script.render = render

export default script